/**
 * 全站 YouTube IFrame API：队列 + 轮询，避免 onYouTubeIframeAPIReady 被覆盖或已触发导致初始化丢失。
 * Pandectes 等 CMP 可能把 iframe 的 src 挪到 data-src，用 promoteYoutubeIframeSrc 在用户交互时恢复。
 */
(function (window, document) {
  'use strict';

  var queue = [];
  var pollTimer = null;
  var MAX_MS = 15000;
  var pollStart = 0;

  function hasYt() {
    return (
      typeof window.YT !== 'undefined' &&
      window.YT &&
      typeof window.YT.Player === 'function'
    );
  }

  function flushQueue() {
    if (!hasYt()) return;
    while (queue.length) {
      var fn = queue.shift();
      try {
        fn();
      } catch (e) {}
    }
  }

  function poll() {
    if (hasYt()) {
      flushQueue();
      pollTimer = null;
      return;
    }
    if (Date.now() - pollStart > MAX_MS) {
      pollTimer = null;
      return;
    }
    pollTimer = setTimeout(poll, 150);
  }

  function startPoll() {
    if (!pollStart) pollStart = Date.now();
    if (!pollTimer) poll();
  }

  function ensureScript() {
    if (document.querySelector('script[src*="youtube.com/iframe_api"]')) {
      startPoll();
      return;
    }
    var prev = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = function () {
      if (typeof prev === 'function') prev();
      flushQueue();
    };
    var tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    var first = document.getElementsByTagName('script')[0];
    first.parentNode.insertBefore(tag, first);
    startPoll();
  }

  function ready(fn) {
    if (typeof fn !== 'function') return;
    if (hasYt()) {
      try {
        fn();
      } catch (e) {}
      return;
    }
    queue.push(fn);
    ensureScript();
  }

  function promoteYoutubeIframeSrc(root) {
    var el = root;
    if (!el) el = document.body;
    if (typeof el === 'string') el = document.querySelector(el);
    if (!el || !el.querySelectorAll) return;
    var iframes = el.querySelectorAll('iframe[data-src]');
    for (var i = 0; i < iframes.length; i++) {
      var iframe = iframes[i];
      var ds = iframe.getAttribute('data-src');
      if (!ds) continue;
      var src = iframe.getAttribute('src') || '';
      var decoded = ds.replace(/&amp;/g, '&');
      var bad =
        !src || src === 'about:blank' || src.indexOf('youtube.com') === -1;
      if (bad) iframe.setAttribute('src', decoded);
    }
  }

  ensureScript();

  window.ShokzYouTubeIframe = {
    ready: ready,
    ensureScript: ensureScript,
    promoteYoutubeIframeSrc: promoteYoutubeIframeSrc,
  };
})(window, document);
